import { CloneRest } from '../clone/type.mjs';
// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------
import { IsIntersect, IsUnion, IsTuple } from '../guard/type.mjs';
// prettier-ignore
function RestResolve(T) {
    return (IsIntersect(T) ? [...T.allOf] :
        IsUnion(T) ? [...T.anyOf] :
            IsTuple(T) ? [...(T.items ?? [])] :
                []);
}
/** `[Json]` Extracts interior Rest elements from Tuple, Intersect and Union types */
export function Rest(T) {
    return CloneRest(RestResolve(T));
}
